import React from 'react';
import { motion } from 'framer-motion';
import { FileText, FileStack, Calendar, LayoutGrid } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    icon: FileText,
    text: 'El PDF completo (guía + frameworks + checklists)'
  }, {
    icon: FileStack,
    text: 'Banco de 30 guiones plantillas (listas para adaptar)'
  }, {
    icon: Calendar,
    text: 'Calendario 14×1 (qué publicar cada día)'
  }, {
    icon: LayoutGrid,
    text: 'Plantillas (Notion/Sheets): tracker + tablero + hooks'
  }];
  return <section className="w-full max-w-2xl mx-auto px-4 py-16" data-id="element-130">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} data-id="element-131">
        <h2 className="text-3xl font-bold text-white mb-8 text-center" data-id="element-132">
          Qué incluye exactamente
        </h2>

        <div className="grid grid-cols-1 gap-4" data-id="element-133">
          {items.map((item, index) => <div key={index} className="flex items-center gap-4 bg-[#1A1A1A] p-5 rounded-xl border border-white/5 hover:border-white/20 transition-colors" data-id="element-134">
              <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center shrink-0" data-id="element-135">
                <item.icon className="w-6 h-6 text-[#25F4EE]" data-id="element-136" />
              </div>
              <span className="text-lg text-gray-200 font-medium" data-id="element-137">
                {item.text}
              </span>
            </div>)}
        </div>
      </motion.div>
    </section>;
}